<div
  class="specialValue {{isDoubleRow ? 'doubleRow': 'none'}} {{ useData[0]?.isBelowNegativeDontShow ? 'isBelowNegativeDontShow' : ''}} {{isEmptyType ? 'nonVisible' : ''}}"
  *ngIf="specialValShow && useData[0]?.OddTypeId !== 1591 && useData[0]?.OddTypeId !== 1518 && useData[0]?.OddTypeId !== 1902">
  <p>{{ useData[0]?.SpecialBetValue}}</p>
  <p *ngIf="isAppend && !isSecondHalf" class="isHalf">1.{{"half" | t}}</p>
  <p *ngIf="isAppend && isSecondHalf" class="isHalfSecond">2.{{"half" | t}}</p>
</div>

<!-- Goalscorer Special Layout -->
<div class="goalscorer-container" *ngIf="useData[0]?.OddTypeId === 1591 || useData[0]?.OddTypeId === 1518 || useData[0]?.OddTypeId === 1902">
  <ng-container *ngFor="let i of useData; let index = index">
    <div class="goalscorer-item {{checkSelected(i?.OddId)}} {{i?.OddValueStatus}}"
         (click)="clickOddUP(i, i?.BetStatus != 'none' || i?.Visibility != 'hidden', !checkSelected(i?.OddId) )"
         *ngIf="i?.BetStatus != 'none' || i?.Visibility != 'hidden'">
      <div class="player-info">
        <span class="player-name">{{i?.OutCome}}</span>
      </div>
      <div class="odd-value">{{i?.OddValue}}</div>
    </div>
  </ng-container>
</div>

<!-- Regular Layout -->
<div class="oddContanier  {{isWrapped ? 'wrap': ''}} {{isDoubleWrap ? 'doubleWrap': ''}} {{useData[0]?.OddTypeId === 1838 ? 'correct-score': ''}}" *ngIf="useData[0]?.OddTypeId !== 1591 && useData[0]?.OddTypeId !== 1518 && useData[0]?.OddTypeId !== 1902">
  <ng-container *ngFor="let i of useData; let index = index">
      <div class="oddItem {{checkSelected(i?.OddId)}} {{i?.OddValueStatus}} {{(i?.OddId === -1 && isExpandView) || isEmptyType ? 'nonVisible  ' : ''}} {{hidingOfThird && index == 2 ? 'nonVisible' : ''}} {{hidingOfFirst && index == 2 ? 'nonVisible' : ''}} {{isSecondHalf ? 'secondHalf':''}}"
           (click)="clickOddUP(i, i?.BetStatus != 'none' || i?.Visibility != 'hidden', !checkSelected(i?.OddId))"
           *ngIf="!(i?.OddId === -1 && isExpandView && !i?.isBelowNegativeDontShow)">
          <p *ngIf="i?.hasUpperText" class="upperText">{{i?.upperText}}</p>
          <ng-container *ngIf="i?.BetStatus != 'none' || i?.Visibility != 'hidden' ">
              {{i?.OddValue}}
          </ng-container>
      </div>
  </ng-container>
</div>